<template>
  <section
    v-if="variant === variants.v1"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor});`"
  >
    <div class="tw-container tw-mx-auto tw-px-4">
      <div
        class="tw-mx-auto tw-max-w-7xl tw-rounded-md tw-border tw-border-gray-700 tw-p-8 lg:tw-p-12"
        :style="`
          background-color: var(--c-${vars.cardBackgroundColor});
          border: 1px solid #666;
        `"
      >
        <div class="tw-flex tw-flex-col tw-gap-5 xl:tw-flex-row xl:tw-gap-2">
          <!-- Sol taraf: Başlık ve çalışma saatleri -->
          <div class="tw-flex-1">
            <!-- Başlık -->
            <h2 v-if="vars.titleText && !vars.titleHtml" class="mb-4">
              {{ vars.titleText }}
            </h2>
            <div v-if="vars.titleHtml" clas="mb-4" v-html="vars.titleHtml"></div>

            <!-- Çalışma saatleri -->
            <div v-for="(branch, index) in branches" :key="`contact-us-branch-${index}`" class="tw-space-y-1">
              <div class="tw-mb-2 tw-text-xs tw-uppercase" :style="`color: var(--c-text_primary) !important;`">
                OPENING HOURS
              </div>

              <div class="tw-space-y-1.5">
                <div class="tw-flex tw-max-w-xs tw-items-center tw-justify-between tw-text-sm">
                  <p :style="`color: var(--c-text_black);`">Monday</p>
                  <p :style="`color: var(--c-text_black);`">{{ branch.monday }}</p>
                </div>
                <div class="tw-flex tw-max-w-xs tw-items-center tw-justify-between tw-text-sm">
                  <p :style="`color: var(--c-text_black);`">Tuesday</p>
                  <p :style="`color: var(--c-text_black);`">{{ branch.tuesday }}</p>
                </div>
                <div class="tw-flex tw-max-w-xs tw-items-center tw-justify-between tw-text-sm">
                  <p :style="`color: var(--c-text_black);`">Wednesday</p>
                  <p :style="`color: var(--c-text_black);`">{{ branch.wednesday }}</p>
                </div>
                <div class="tw-flex tw-max-w-xs tw-items-center tw-justify-between tw-text-sm">
                  <p :style="`color: var(--c-text_black);`">Thursday</p>
                  <p :style="`color: var(--c-text_black);`">{{ branch.thursday }}</p>
                </div>
                <div class="tw-flex tw-max-w-xs tw-items-center tw-justify-between tw-text-sm">
                  <p :style="`color: var(--c-text_black);`">Friday</p>
                  <p :style="`color: var(--c-text_black);`">{{ branch.friday }}</p>
                </div>
                <div class="tw-flex tw-max-w-xs tw-items-center tw-justify-between tw-text-sm">
                  <p :style="`color: var(--c-text_black);`">Saturday</p>
                  <p :style="`color: var(--c-text_black);`">{{ branch.saturday }}</p>
                </div>
                <div class="tw-flex tw-max-w-xs tw-items-center tw-justify-between tw-text-sm">
                  <p :style="`color: var(--c-text_black);`">Sunday</p>
                  <p :style="`color: var(--c-text_black);`">{{ branch.sunday }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Sağ taraf: İkinci başlık ve sosyal ikonlar -->
          <div class="tw-flex-1 tw-text-left xl:tw-text-left">
            <!-- Başlık -->
            <h2 class="tw-mb-5" :style="`color: var(--c-text_black);`">
              {{ vars.secondaryTitleText }}
            </h2>

            <!-- Sosyal ikonlar -->
            <div>
              <small class="tw-mb-3 tw-block tw-uppercase" :style="`color: var(--c-text_primary) !important;`">
                SOCIALS
              </small>

              <div class="tw-flex tw-items-start tw-justify-start tw-gap-3 xl:tw-justify-start">
                <nuxt-link
                  v-if="vars.facebookUrl"
                  :external="true"
                  :to="String(vars.facebookUrl)"
                  target="_blank"
                  class="n-link tw-group"
                >
                  <span>
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#EF787C" class="tw-duration-300 group-hover:tw-fill-white" />
                      <path
                        d="M19.3307 19.0002H20.9974L21.6641 16.3335H19.3307V15.0002C19.3307 14.3135 19.3307 13.6668 20.6641 13.6668H21.6641V11.4268C21.4467 11.3982 20.6261 11.3335 19.7594 11.3335C17.9494 11.3335 16.6641 12.4382 16.6641 14.4668V16.3335H14.6641V19.0002H16.6641V24.6668H19.3307V19.0002Z"
                        fill="#2b2b2b"
                      />
                    </svg>
                  </span>
                </nuxt-link>

                <nuxt-link
                  v-if="vars.instagramUrl"
                  :external="true"
                  :to="String(vars.instagramUrl)"
                  target="_blank"
                  class="n-link tw-group"
                >
                  <span>
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#EF787C" class="tw-duration-300 group-hover:tw-fill-white" />
                      <path
                        d="M15.2026 11.3335H20.8026C22.9359 11.3335 24.6693 13.0668 24.6693 15.2002V20.8002C24.6693 21.8257 24.2619 22.8092 23.5367 23.5343C22.8116 24.2594 21.8281 24.6668 20.8026 24.6668H15.2026C13.0693 24.6668 11.3359 22.9335 11.3359 20.8002V15.2002C11.3359 14.1747 11.7433 13.1912 12.4685 12.466C13.1936 11.7409 14.1771 11.3335 15.2026 11.3335ZM15.0693 12.6668C14.4328 12.6668 13.8223 12.9197 13.3722 13.3698C12.9221 13.8199 12.6693 14.4303 12.6693 15.0668V20.9335C12.6693 22.2602 13.7426 23.3335 15.0693 23.3335H20.9359C21.5725 23.3335 22.1829 23.0806 22.633 22.6306C23.0831 22.1805 23.3359 21.57 23.3359 20.9335V15.0668C23.3359 13.7402 22.2626 12.6668 20.9359 12.6668H15.0693ZM21.5026 13.6668C21.7236 13.6668 21.9356 13.7546 22.0919 13.9109C22.2481 14.0672 22.3359 14.2791 22.3359 14.5002C22.3359 14.7212 22.2481 14.9331 22.0919 15.0894C21.9356 15.2457 21.7236 15.3335 21.5026 15.3335C21.2816 15.3335 21.0696 15.2457 20.9133 15.0894C20.7571 14.9331 20.6693 14.7212 20.6693 14.5002C20.6693 14.2791 20.7571 14.0672 20.9133 13.9109C21.0696 13.7546 21.2816 13.6668 21.5026 13.6668ZM18.0026 14.6668C18.8867 14.6668 19.7345 15.018 20.3596 15.6431C20.9847 16.2683 21.3359 17.1161 21.3359 18.0002C21.3359 18.8842 20.9847 19.7321 20.3596 20.3572C19.7345 20.9823 18.8867 21.3335 18.0026 21.3335C17.1185 21.3335 16.2707 20.9823 15.6456 20.3572C15.0205 19.7321 14.6693 18.8842 14.6693 18.0002C14.6693 17.1161 15.0205 16.2683 15.6456 15.6431C16.2707 15.018 17.1185 14.6668 18.0026 14.6668ZM18.0026 16.0002C17.4722 16.0002 16.9635 16.2109 16.5884 16.5859C16.2133 16.961 16.0026 17.4697 16.0026 18.0002C16.0026 18.5306 16.2133 19.0393 16.5884 19.4144C16.9635 19.7894 17.4722 20.0002 18.0026 20.0002C18.533 20.0002 19.0417 19.7894 19.4168 19.4144C19.7919 19.0393 20.0026 18.5306 20.0026 18.0002C20.0026 17.4697 19.7919 16.961 19.4168 16.5859C19.0417 16.2109 18.533 16.0002 18.0026 16.0002Z"
                        fill="#2b2b2b"
                      />
                    </svg>
                  </span>
                </nuxt-link>

                <nuxt-link
                  v-if="vars.linkedinUrl"
                  :external="true"
                  :to="String(vars.linkedinUrl)"
                  target="_blank"
                  class="n-link tw-group"
                >
                  <span>
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#EF787C" class="tw-duration-300 group-hover:tw-fill-white" />
                      <path
                        d="M14.6276 13.3335C14.6274 13.6871 14.4868 14.0262 14.2366 14.2761C13.9864 14.526 13.6472 14.6664 13.2936 14.6662C12.94 14.666 12.6009 14.5254 12.351 14.2752C12.1011 14.025 11.9608 13.6858 11.9609 13.3322C11.9611 12.9786 12.1018 12.6395 12.3519 12.3896C12.6021 12.1396 12.9413 11.9993 13.2949 11.9995C13.6486 11.9997 13.9876 12.1403 14.2376 12.3905C14.4875 12.6407 14.6278 12.9799 14.6276 13.3335ZM14.6676 15.6535H12.0009V24.0002H14.6676V15.6535ZM18.8809 15.6535H16.2276V24.0002H18.8543V19.6202C18.8543 17.1802 22.0343 16.9535 22.0343 19.6202V24.0002H24.6676V18.7135C24.6676 14.6002 19.9609 14.7535 18.8543 16.7735L18.8809 15.6535Z"
                        fill="#2b2b2b"
                      />
                    </svg>
                  </span>
                </nuxt-link>

                <nuxt-link
                  v-if="vars.youtubeUrl"
                  :external="true"
                  :to="String(vars.youtubeUrl)"
                  target="_blank"
                  class="n-link tw-group"
                >
                  <span>
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#EF787C" class="tw-duration-300 group-hover:tw-fill-white" />
                      <path
                        d="M18.0026 12.6665C18.5726 12.6665 19.1573 12.6812 19.7239 12.7052L20.3933 12.7372L21.0339 12.7752L21.6339 12.8158L22.1819 12.8585C22.7766 12.904 23.3362 13.1578 23.7623 13.5752C24.1883 13.9926 24.4536 14.5469 24.5113 15.1405L24.5379 15.4238L24.5879 16.0305C24.6346 16.6592 24.6693 17.3445 24.6693 17.9998C24.6693 18.6552 24.6346 19.3405 24.5879 19.9692L24.5379 20.5758C24.5293 20.6732 24.5206 20.7672 24.5113 20.8592C24.4535 21.4529 24.1882 22.0073 23.762 22.4247C23.3358 22.8421 22.7761 23.0958 22.1813 23.1412L21.6346 23.1832L21.0346 23.2245L20.3933 23.2625L19.7239 23.2945C19.1505 23.3194 18.5766 23.3323 18.0026 23.3332C17.4286 23.3323 16.8547 23.3194 16.2813 23.2945L15.6119 23.2625L14.9713 23.2245L14.3713 23.1832L13.8233 23.1412C13.2286 23.0957 12.669 22.8419 12.2429 22.4245C11.8169 22.0071 11.5517 21.4528 11.4939 20.8592L11.4673 20.5758L11.4173 19.9692C11.3663 19.3139 11.3392 18.6571 11.3359 17.9998C11.3359 17.3445 11.3706 16.6592 11.4173 16.0305L11.4673 15.4238C11.4759 15.3265 11.4846 15.2325 11.4939 15.1405C11.5516 14.547 11.8167 13.9928 12.2427 13.5754C12.6686 13.158 13.228 12.9042 13.8226 12.8585L14.3699 12.8158L14.9699 12.7752L15.6113 12.7372L16.2806 12.7052C16.8543 12.6803 17.4284 12.6674 18.0026 12.6665ZM18.0026 13.9998C17.4526 13.9998 16.8866 14.0145 16.3359 14.0372L15.6839 14.0685L15.0579 14.1052L14.4699 14.1452L13.9313 14.1872C13.6482 14.2073 13.3813 14.3269 13.178 14.525C12.9747 14.723 12.8481 14.9867 12.8206 15.2692C12.7426 16.0752 12.6693 17.0785 12.6693 17.9998C12.6693 18.9212 12.7426 19.9245 12.8206 20.7305C12.8773 21.3118 13.3386 21.7638 13.9313 21.8125L14.4699 21.8538L15.0579 21.8938L15.6839 21.9312L16.3359 21.9625C16.8866 21.9852 17.4526 21.9998 18.0026 21.9998C18.5526 21.9998 19.1186 21.9852 19.6693 21.9625L20.3213 21.9312L20.9473 21.8945L21.5353 21.8545L22.0739 21.8125C22.357 21.7924 22.6239 21.6727 22.8272 21.4747C23.0305 21.2766 23.1571 21.013 23.1846 20.7305C23.2626 19.9245 23.3359 18.9212 23.3359 17.9998C23.3359 17.0785 23.2626 16.0752 23.1846 15.2692C23.1571 14.9867 23.0305 14.723 22.8272 14.525C22.6239 14.3269 22.357 14.2073 22.0739 14.1872L21.5353 14.1458L20.9473 14.1058L20.3213 14.0685L19.6693 14.0372C19.114 14.0133 18.5584 14.0008 18.0026 13.9998ZM16.6693 16.3832C16.6692 16.318 16.6851 16.2538 16.7155 16.1962C16.7459 16.1386 16.79 16.0893 16.8438 16.0525C16.8976 16.0158 16.9596 15.9928 17.0243 15.9854C17.0891 15.9781 17.1546 15.9867 17.2153 16.0105L17.2693 16.0372L20.0693 17.6532C20.125 17.6853 20.1722 17.7305 20.2068 17.7848C20.2413 17.8391 20.2623 17.9009 20.2679 17.9651C20.2734 18.0292 20.2634 18.0937 20.2387 18.1532C20.214 18.2126 20.1753 18.2652 20.1259 18.3065L20.0693 18.3465L17.2693 19.9632C17.2128 19.9958 17.1493 20.0142 17.0841 20.0167C17.019 20.0192 16.9542 20.0058 16.8954 19.9775C16.8367 19.9492 16.7857 19.907 16.747 19.8546C16.7083 19.8021 16.683 19.741 16.6733 19.6765L16.6693 19.6165V16.3832Z"
                        fill="#2b2b2b"
                      />
                    </svg>
                  </span>
                </nuxt-link>

                <nuxt-link
                  v-if="vars.tiktokUrl"
                  :external="true"
                  :to="String(vars.tiktokUrl)"
                  target="_blank"
                  class="n-link tw-group"
                >
                  <span>
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#EF787C" class="tw-duration-300 group-hover:tw-fill-white" />
                      <path
                        d="M21.0668 13.88C20.6111 13.3597 20.3599 12.6916 20.3601 12H18.3001V20.2667C18.2842 20.714 18.0954 21.1377 17.7733 21.4486C17.4512 21.7595 17.0211 21.9333 16.5734 21.9333C15.6268 21.9333 14.8401 21.16 14.8401 20.2C14.8401 19.0533 15.9468 18.1933 17.0868 18.5467V16.44C14.7868 16.1333 12.7734 17.92 12.7734 20.2C12.7734 22.42 14.6134 24 16.5668 24C18.6601 24 20.3601 22.3 20.3601 20.2V16.0067C21.1954 16.6066 22.1983 16.9284 23.2268 16.9267V14.8667C23.2268 14.8667 21.9734 14.9267 21.0668 13.88Z"
                        fill="#2b2b2b"
                      />
                    </svg>
                  </span>
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variant === variants.v2"
    class="tw-relative tw-py-20 tw-text-white"
    :style="{
      backgroundColor: `var(--c-${vars.backgroundColor})`,
      color: `var(--c-${vars.textColor})`,
      '--social-icon-path-color': `var(--c-${vars.backgroundColor})`,
      '--social-icon-circle-color': `var(--c-${vars.textColor})`,
    }"
  >
    <div class="tw-hidden lg:tw-block">
      <BlockSymbol
        :block-logo-image="String(vars.blockLogoImage || '')"
        :position-text="String(vars.blockPositionText || 'center')"
        image-class="tw-w-full tw-h-full tw-object-contain"
      />
    </div>

    <div class="tw-block lg:tw-hidden">
      <BlockSymbol
        :block-logo-image="String(vars.blockLogoImage || '')"
        position-text="mobile_bottom_center"
        image-class="tw-w-full tw-object-contain"
      />
    </div>
    <div class="tw-container tw-relative tw-mx-auto tw-px-4">
      <div class="tw-flex tw-flex-col tw-gap-12 lg:tw-flex-row lg:tw-gap-24">
        <!-- Left Column -->
        <div class="lg:tw-w-1/2">
          <div class="tw-mb-12" v-html="vars.titleHtml"></div>

          <div class="tw-space-y-6">
            <h6 :style="`color: var(--c-${vars.textTertiary});`">OPENING HOURS</h6>
            <div v-for="(branch, index) in branches" :key="`opening-hour-${index}`" class="tw-space-y-1">
              <div class="tw-flex tw-max-w-sm tw-items-center tw-justify-between">
                <p class="tw-font-medium">{{ branch.title }}</p>
                <div class="tw-text-right">
                  <p class="tw-font-medium">{{ branch.description }}</p>
                  <p class="tw-text-sm" :style="`color: var(--c-${vars.textTertiary});`">
                    {{ branch.sub_description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column -->
        <div class="lg:tw-w-1/2">
          <div class="tw-mb-8" v-html="vars.secondaryTitleHtml"></div>

          <p class="tw-mb-6" :style="`color: var(--c-${vars.textTertiary});`">
            {{ vars.descriptionText }}
          </p>

          <div class="tw-flex tw-items-center tw-gap-3">
            <nuxt-link
              v-if="vars.facebookUrl"
              :external="true"
              :to="String(vars.facebookUrl)"
              target="_blank"
              class="n-link"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" :fill="`var(--social-icon-circle-color)`" />
                  <path
                    d="M19.3307 19.0002H20.9974L21.6641 16.3335H19.3307V15.0002C19.3307 14.3135 19.3307 13.6668 20.6641 13.6668H21.6641V11.4268C21.4467 11.3982 20.6261 11.3335 19.7594 11.3335C17.9494 11.3335 16.6641 12.4382 16.6641 14.4668V16.3335H14.6641V19.0002H16.6641V24.6668H19.3307V19.0002Z"
                    :fill="`var(--social-icon-path-color)`"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.instagramUrl"
              :external="true"
              :to="String(vars.instagramUrl)"
              target="_blank"
              class="n-link"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" :fill="`var(--social-icon-circle-color)`" />
                  <path
                    d="M15.2026 11.3335H20.8026C22.9359 11.3335 24.6693 13.0668 24.6693 15.2002V20.8002C24.6693 21.8257 24.2619 22.8092 23.5367 23.5343C22.8116 24.2594 21.8281 24.6668 20.8026 24.6668H15.2026C13.0693 24.6668 11.3359 22.9335 11.3359 20.8002V15.2002C11.3359 14.1747 11.7433 13.1912 12.4685 12.466C13.1936 11.7409 14.1771 11.3335 15.2026 11.3335ZM15.0693 12.6668C14.4328 12.6668 13.8223 12.9197 13.3722 13.3698C12.9221 13.8199 12.6693 14.4303 12.6693 15.0668V20.9335C12.6693 22.2602 13.7426 23.3335 15.0693 23.3335H20.9359C21.5725 23.3335 22.1829 23.0806 22.633 22.6306C23.0831 22.1805 23.3359 21.57 23.3359 20.9335V15.0668C23.3359 13.7402 22.2626 12.6668 20.9359 12.6668H15.0693ZM21.5026 13.6668C21.7236 13.6668 21.9356 13.7546 22.0919 13.9109C22.2481 14.0672 22.3359 14.2791 22.3359 14.5002C22.3359 14.7212 22.2481 14.9331 22.0919 15.0894C21.9356 15.2457 21.7236 15.3335 21.5026 15.3335C21.2816 15.3335 21.0696 15.2457 20.9133 15.0894C20.7571 14.9331 20.6693 14.7212 20.6693 14.5002C20.6693 14.2791 20.7571 14.0672 20.9133 13.9109C21.0696 13.7546 21.2816 13.6668 21.5026 13.6668ZM18.0026 14.6668C18.8867 14.6668 19.7345 15.018 20.3596 15.6431C20.9847 16.2683 21.3359 17.1161 21.3359 18.0002C21.3359 18.8842 20.9847 19.7321 20.3596 20.3572C19.7345 20.9823 18.8867 21.3335 18.0026 21.3335C17.1185 21.3335 16.2707 20.9823 15.6456 20.3572C15.0205 19.7321 14.6693 18.8842 14.6693 18.0002C14.6693 17.1161 15.0205 16.2683 15.6456 15.6431C16.2707 15.018 17.1185 14.6668 18.0026 14.6668ZM18.0026 16.0002C17.4722 16.0002 16.9635 16.2109 16.5884 16.5859C16.2133 16.961 16.0026 17.4697 16.0026 18.0002C16.0026 18.5306 16.2133 19.0393 16.5884 19.4144C16.9635 19.7894 17.4722 20.0002 18.0026 20.0002C18.533 20.0002 19.0417 19.7894 19.4168 19.4144C19.7919 19.0393 20.0026 18.5306 20.0026 18.0002C20.0026 17.4697 19.7919 16.961 19.4168 16.5859C19.0417 16.2109 18.533 16.0002 18.0026 16.0002Z"
                    :fill="`var(--social-icon-path-color)`"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.linkedinUrl"
              :external="true"
              :to="String(vars.linkedinUrl)"
              target="_blank"
              class="n-link"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" :fill="`var(--social-icon-circle-color)`" />
                  <path
                    d="M14.6276 13.3335C14.6274 13.6871 14.4868 14.0262 14.2366 14.2761C13.9864 14.526 13.6472 14.6664 13.2936 14.6662C12.94 14.666 12.6009 14.5254 12.351 14.2752C12.1011 14.025 11.9608 13.6858 11.9609 13.3322C11.9611 12.9786 12.1018 12.6395 12.3519 12.3896C12.6021 12.1396 12.9413 11.9993 13.2949 11.9995C13.6486 11.9997 13.9876 12.1403 14.2376 12.3905C14.4875 12.6407 14.6278 12.9799 14.6276 13.3335ZM14.6676 15.6535H12.0009V24.0002H14.6676V15.6535ZM18.8809 15.6535H16.2276V24.0002H18.8543V19.6202C18.8543 17.1802 22.0343 16.9535 22.0343 19.6202V24.0002H24.6676V18.7135C24.6676 14.6002 19.9609 14.7535 18.8543 16.7735L18.8809 15.6535Z"
                    :fill="`var(--social-icon-path-color)`"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.youtubeUrl"
              :external="true"
              :to="String(vars.youtubeUrl)"
              target="_blank"
              class="n-link"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" :fill="`var(--social-icon-circle-color)`" />
                  <path
                    d="M18.0026 12.6665C18.5726 12.6665 19.1573 12.6812 19.7239 12.7052L20.3933 12.7372L21.0339 12.7752L21.6339 12.8158L22.1819 12.8585C22.7766 12.904 23.3362 13.1578 23.7623 13.5752C24.1883 13.9926 24.4536 14.5469 24.5113 15.1405L24.5379 15.4238L24.5879 16.0305C24.6346 16.6592 24.6693 17.3445 24.6693 17.9998C24.6693 18.6552 24.6346 19.3405 24.5879 19.9692L24.5379 20.5758C24.5293 20.6732 24.5206 20.7672 24.5113 20.8592C24.4535 21.4529 24.1882 22.0073 23.762 22.4247C23.3358 22.8421 22.7761 23.0958 22.1813 23.1412L21.6346 23.1832L21.0346 23.2245L20.3933 23.2625L19.7239 23.2945C19.1505 23.3194 18.5766 23.3323 18.0026 23.3332C17.4286 23.3323 16.8547 23.3194 16.2813 23.2945L15.6119 23.2625L14.9713 23.2245L14.3713 23.1832L13.8233 23.1412C13.2286 23.0957 12.669 22.8419 12.2429 22.4245C11.8169 22.0071 11.5517 21.4528 11.4939 20.8592L11.4673 20.5758L11.4173 19.9692C11.3663 19.3139 11.3392 18.6571 11.3359 17.9998C11.3359 17.3445 11.3706 16.6592 11.4173 16.0305L11.4673 15.4238C11.4759 15.3265 11.4846 15.2325 11.4939 15.1405C11.5516 14.547 11.8167 13.9928 12.2427 13.5754C12.6686 13.158 13.228 12.9042 13.8226 12.8585L14.3699 12.8158L14.9699 12.7752L15.6113 12.7372L16.2806 12.7052C16.8543 12.6803 17.4284 12.6674 18.0026 12.6665ZM18.0026 13.9998C17.4526 13.9998 16.8866 14.0145 16.3359 14.0372L15.6839 14.0685L15.0579 14.1052L14.4699 14.1452L13.9313 14.1872C13.6482 14.2073 13.3813 14.3269 13.178 14.525C12.9747 14.723 12.8481 14.9867 12.8206 15.2692C12.7426 16.0752 12.6693 17.0785 12.6693 17.9998C12.6693 18.9212 12.7426 19.9245 12.8206 20.7305C12.8773 21.3118 13.3386 21.7638 13.9313 21.8125L14.4699 21.8538L15.0579 21.8938L15.6839 21.9312L16.3359 21.9625C16.8866 21.9852 17.4526 21.9998 18.0026 21.9998C18.5526 21.9998 19.1186 21.9852 19.6693 21.9625L20.3213 21.9312L20.9473 21.8945L21.5353 21.8545L22.0739 21.8125C22.357 21.7924 22.6239 21.6727 22.8272 21.4747C23.0305 21.2766 23.1571 21.013 23.1846 20.7305C23.2626 19.9245 23.3359 18.9212 23.3359 17.9998C23.3359 17.0785 23.2626 16.0752 23.1846 15.2692C23.1571 14.9867 23.0305 14.723 22.8272 14.525C22.6239 14.3269 22.357 14.2073 22.0739 14.1872L21.5353 14.1458L20.9473 14.1058L20.3213 14.0685L19.6693 14.0372C19.114 14.0133 18.5584 14.0008 18.0026 13.9998ZM16.6693 16.3832C16.6692 16.318 16.6851 16.2538 16.7155 16.1962C16.7459 16.1386 16.79 16.0893 16.8438 16.0525C16.8976 16.0158 16.9596 15.9928 17.0243 15.9854C17.0891 15.9781 17.1546 15.9867 17.2153 16.0105L17.2693 16.0372L20.0693 17.6532C20.125 17.6853 20.1722 17.7305 20.2068 17.7848C20.2413 17.8391 20.2623 17.9009 20.2679 17.9651C20.2734 18.0292 20.2634 18.0937 20.2387 18.1532C20.214 18.2126 20.1753 18.2652 20.1259 18.3065L20.0693 18.3465L17.2693 19.9632C17.2128 19.9958 17.1493 20.0142 17.0841 20.0167C17.019 20.0192 16.9542 20.0058 16.8954 19.9775C16.8367 19.9492 16.7857 19.907 16.747 19.8546C16.7083 19.8021 16.683 19.741 16.6733 19.6765L16.6693 19.6165V16.3832Z"
                    :fill="`var(--social-icon-path-color)`"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.tiktokUrl"
              :external="true"
              :to="String(vars.tiktokUrl)"
              target="_blank"
              class="n-link"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" :fill="`var(--social-icon-circle-color)`" />
                  <path
                    d="M21.0668 13.88C20.6111 13.3597 20.3599 12.6916 20.3601 12H18.3001V20.2667C18.2842 20.714 18.0954 21.1377 17.7733 21.4486C17.4512 21.7595 17.0211 21.9333 16.5734 21.9333C15.6268 21.9333 14.8401 21.16 14.8401 20.2C14.8401 19.0533 15.9468 18.1933 17.0868 18.5467V16.44C14.7868 16.1333 12.7734 17.92 12.7734 20.2C12.7734 22.42 14.6134 24 16.5668 24C18.6601 24 20.3601 22.3 20.3601 20.2V16.0067C21.1954 16.6066 22.1983 16.9284 23.2268 16.9267V14.8667C23.2268 14.8667 21.9734 14.9267 21.0668 13.88Z"
                    :fill="`var(--social-icon-path-color)`"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'ContactUs',
  components: { BlockSymbol },
  mixins: [ComponentMixin],

  data() {
    return {
      locations: [],
      form: null,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  computed: {
    branches() {
      return this.groupedVariables.branches;
    },

    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>
